/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AIScanMatch,
  AIScanMatch$Outbound,
  AIScanMatch$outboundSchema,
} from "./aiscanmatch.js";

export type ReportAIScanRequestBody = {
  /**
   * Detection targets the scan matched. Empty when the device came back clean; the report still lands as a scan receipt.
   */
  matches: Array<AIScanMatch>;
  /**
   * When the agent completed the scan.
   */
  scanCompletedAt: Date;
  /**
   * When the agent started the scan.
   */
  scanStartedAt: Date;
  /**
   * Revision of the scan target catalog the agent scanned with: the list_version it last received from getPlugins, or 0 when it fell back to the list embedded in its binary. Echoed into the scan receipt as reported.
   */
  targetListVersion: number;
};

/** @internal */
export type ReportAIScanRequestBody$Outbound = {
  matches: Array<AIScanMatch$Outbound>;
  scan_completed_at: string;
  scan_started_at: string;
  target_list_version: number;
};

/** @internal */
export const ReportAIScanRequestBody$outboundSchema: z.ZodMiniType<
  ReportAIScanRequestBody$Outbound,
  ReportAIScanRequestBody
> = z.pipe(
  z.object({
    matches: z.array(AIScanMatch$outboundSchema),
    scanCompletedAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    scanStartedAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    targetListVersion: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      scanCompletedAt: "scan_completed_at",
      scanStartedAt: "scan_started_at",
      targetListVersion: "target_list_version",
    });
  }),
);

export function reportAIScanRequestBodyToJSON(
  reportAIScanRequestBody: ReportAIScanRequestBody,
): string {
  return JSON.stringify(
    ReportAIScanRequestBody$outboundSchema.parse(reportAIScanRequestBody),
  );
}
